import React, { useState } from "react"
import Grid from "@kit/design/grid"
import Stack from "@kit/design/stack"
import Input from "@kit/design/input"
import { Alignment } from "core/alignment"
import { Field } from "core/form"
import { ColorInput } from "core/color-picker"

const isValidUrl = url => {
  if (!url) return true
  return /y[2o]u/.test(url)
}

export const VideoSettings = ({ editor, node }) => {
  const videoNode = node
  const href = videoNode.data.get("href") || ""
  const alignment = videoNode.data.get("alignment") || "center"
  const width = videoNode.data.get("width") || 480
  const accentColor = videoNode.data.get("accentColor") || "#1677BE"
  const playButtonColor = videoNode.data.get("playButtonColor") || "#FFFFFF"

  const [video, setVideo] = useState({
    href,
    alignment,
    width,
    accentColor,
    playButtonColor
  })

  const setVideoData = event => {
    const { name, value } = event.target
    setVideo(currentVideo => ({ ...currentVideo, [name]: value }))
    editor.command("setNodeByKey", videoNode.key, {
      data: { ...video, [name]: value }
    })
  }

  const onKeyDown = event => {
    if (event.key === "Enter") event.preventDefault()
  }

  return (
    <Stack spacing={3}>
      <Field
        control={Input}
        label="YouTube video URL"
        name="href"
        value={video.href}
        onChange={setVideoData}
        onKeyDown={onKeyDown}
        controlClassName="ck-input"
      >
        {!isValidUrl(video.href) && (
          <p style={{ fontSize: "0.75em" }}>This URL is not a YouTube link</p>
        )}
      </Field>
      <Grid columns="repeat(2, 50%)" gap=".5rem" rowGap=".75rem">
        <Field
          control={ColorInput}
          label="Accent color"
          name="accentColor"
          onChange={setVideoData}
          value={video.accentColor}
        />
        <Field
          control={ColorInput}
          label="Play button color"
          name="playButtonColor"
          onChange={setVideoData}
          value={video.playButtonColor}
        />
      </Grid>
      <Grid columns="repeat(2, 50%)" gap=".5rem" rowGap=".75rem">
        <Field
          control={Input}
          label="Video size"
          type="number"
          name="width"
          min={100}
          max={480}
          value={video.width}
          onChange={setVideoData}
        />
        <Stack spacing={2}>
          <div className="inline-block text-xs font-semibold leading-snug text-gray-800 mb-1">
            Alignment
          </div>
          <Alignment
            alignment={video.alignment}
            onChange={({ name, value }) =>
              setVideoData({ target: { name, value } })
            }
          />
        </Stack>
      </Grid>
      <p className="text-gray-700 text-xs italic" style={{ maxWidth: "240px" }}>
        Want to embed the video inline?
        <br />
        Click the + icon and select &apos;Video&apos;.
      </p>
    </Stack>
  )
}
